import { createSubscriptionHook } from '~/shared/providers/api';

export const useCameraEventsSubscription = createSubscriptionHook(
  'iot.cameraEvents',
  () => ({
    iotCameraEvents: {
      id: true,
      name: true,
      status: true,
    },
  }),
  {
    select: ({ iotCameraEvents }) => iotCameraEvents,
  },
);
